const toggleElement = (element, relatedElement) => element.classList.toggle(
    'hide',
    relatedElement.classList.contains('hide')
);

const relatedFormSectionsToggle = () => {
    const formSections = document.querySelectorAll('[data-related-form-section]');

    if (!formSections.length) {
        return;
    }

    formSections.forEach((formSection) => {
        const relatedFormSectionSelector = formSection.dataset.relatedFormSection;
        const relatedFormSection = document.querySelector(relatedFormSectionSelector);

        if (!relatedFormSection) {
            return;
        }

        toggleElement(formSection, relatedFormSection);

        const relatedFormSectionObserver = new MutationObserver(() =>
            toggleElement(formSection, relatedFormSection)
        );

        relatedFormSectionObserver.observe(relatedFormSection, {
            attributes: true,
            childList: false,
            subtree: false
        });
    });
};

export default relatedFormSectionsToggle;
